<div id="page-container">
  <div id="hash-container" class="flex flex-row gap-10 align-items-start">
    <img src="assets/hash-icon.svg" class="icon-inline">
    <div class="flex flex-column">
      <h1 class="light-blue text-lg no-margin">EMPREINTES</h1>
      <p class="grey text-sm no-margin">Les empreintes cryptographiques sont des condensats (hash) générés à partir des
        fichiers
        ou composants du système afin de garantir leur authenticité et de détecter toute modification non autorisée.</p>
    </div>
  </div>

  <div id="hash-filters" class="flex flex-row gap-10 align-items-center">
    <img src="assets/filters-icon.svg" class="icon-inline" style="margin-left: 41px;">
    <p class="dark-blue text-sm">Type :</p>
    <select id="audit-mode" name="audit-mode" [(ngModel)]="filterValue" (ngModelChange)="onFilterChange()">
      <option value="tous">Tous</option>
      <option value="hash-election">Hash paramètres de l'élection</option>
      <option value="hash-version">Hash version applicative</option>
      <option value="hash-candidats">Hash liste des candidats</option>
      <option value="hash-votants">Hash liste des électeurs</option>
      <option value="empreinte-emergement">Empreinte liste d'émargement</option>
      <option value="empreinte-urne">Empreinte urne</option>
      <option value="coherence">Cohérence urne/émargement</option>
      <option value="hash-logs">Hash du journal des événements</option>
    </select>
    <button class="flex align-items-center flex-row" id="download-report" (click)="downloadReport()"><img
        src="assets/download-icon.svg" class="icon-inline">Télécharger le rapport</button>
  </div>

  <div>
    <p-table [value]="filteredAuditComparisons" [tableStyle]="{'width': '100%'}" styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="time" style="width:20%">
            Date / Heure <p-sortIcon field="time" />
          </th>
          <th pSortableColumn="lineName" style="width:20%">
            Élément contrôlé <p-sortIcon field="lineName" />
          </th>
          <th pSortableColumn="initialHash" style="width:18%">
            Empreinte initiale <p-sortIcon field="initialHash" />
          </th>
          <th pSortableColumn="currentHash" style="width:19%">
            Empreinte actuelle <p-sortIcon field="currentHash" />
          </th>
          <th pSortableColumn="hashComparison" style="width:13%">
            Conformité <p-sortIcon field="hashComparison" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-audit>
        <tr>
          <td>{{ audit.time }}</td>
          <td>{{ audit.lineName }}</td>
          <td>{{ audit.initialHash }}</td>
          <td>{{ audit.currentHash }}</td>
          <td [ngClass]="isAuditCompliant(audit.hashComparison) === 'Conforme' ? 'green' : 'red'">
            <div class="flex align-items-center" style="height: 100%;"><span
              id="bullet" class="rounded mr-5" [ngClass]="isAuditCompliant(audit.hashComparison) === 'Conforme' ? 'bg-green' : 'bg-red'"></span>{{ isAuditCompliant(audit.hashComparison) }}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="flex flex-column gap-10 content-center align-items-center">
    <p class="dark-blue"><img src="assets/flag-icon.svg" class="icon-inline"><span class="bold light-blue"> Dernier
        recalcul : </span> <span class="bold">{{ lastAudit.auditOwner }}</span>,
      le {{getAuditDate()}}</p>
    <button class="action-button" (click)="startAudit()">Déclencher le contrôle</button>
    <p *ngIf="auditSuccess" class="success-message flex flex-row gap-10 align-items-center"><img
        src="assets/success-icon.svg" class="icon-inline">Contrôle réussi.</p>
  </div>
</div>
